import * as Sentry from '@sentry/remix';

import { ASYNC_STYLESHEET_ATTRIBUTE, ASYNC_STYLESHEET_FAILED_ATTRIBUTE } from './constants';

const MAX_WAIT_MS = 10_000;

// Client-only UI uses classes the server never inlined, so it must not render before the full shared sheets apply.
// A failed or stalled sheet must not leave the page without JavaScript, hence resolving on error and the cap.
export const waitForAsyncStylesheets = () => {
  const pendingLoads = [...document.querySelectorAll<HTMLLinkElement>(`link[${ASYNC_STYLESHEET_ATTRIBUTE}]`)]
    .filter((link) => !link.sheet && !link.hasAttribute(ASYNC_STYLESHEET_FAILED_ATTRIBUTE))
    .map(
      (link) =>
        new Promise<void>((resolve) => {
          link.addEventListener('load', () => resolve(), { once: true });
          link.addEventListener('error', () => resolve(), { once: true });
        }),
    );
  if (pendingLoads.length === 0) return Promise.resolve();
  return Promise.race([
    Promise.all(pendingLoads).then(() => true),
    new Promise<boolean>((resolve) => setTimeout(() => resolve(false), MAX_WAIT_MS)),
  ]).then((settledInTime) => {
    // A stalled sheet throws nothing and client tracing is off, so this is the only signal that the cap fired.
    if (!settledInTime) Sentry.captureMessage('Async stylesheet still loading at hydration cap', { level: 'warning' });
  });
};
